exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".actions[data-v-744c1233] {\n  width: 6%;\n}\n", ""]);

// exports
